import { render } from "./ComprasClasif.vue?vue&type=template&id=4503a070"
import script from "./ComprasClasif.vue?vue&type=script&lang=js"
export * from "./ComprasClasif.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/gastos/ComprasClasif.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4503a070"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4503a070', __exports__)) {
    api.reload('4503a070', __exports__)
  }
  
  module.hot.accept("./ComprasClasif.vue?vue&type=template&id=4503a070", () => {
    api.rerender('4503a070', render)
  })

}


export default __exports__